import { Card, CardBody, Spinner } from '@heroui/react';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { FiUploadCloud } from 'react-icons/fi';

interface CsvDropzoneProps {
  onFile: (file: File) => void;
  isProcessing: boolean;
}

export const CsvDropzone: React.FC<CsvDropzoneProps> = ({
  onFile,
  isProcessing,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (accepted) => {
      if (accepted[0]) onFile(accepted[0]);
    },
    accept: { 'text/csv': ['.csv'], 'application/vnd.ms-excel': ['.csv'] },
    multiple: false,
    disabled: isProcessing,
  });

  return (
    <Card>
      <CardBody>
        <div
          {...getRootProps()}
          className={`flex flex-col items-center justify-center gap-3 rounded-lg border-2 border-dashed p-10 cursor-pointer transition-colors ${
            isDragActive
              ? 'border-primary bg-primary-50'
              : 'border-default-300 hover:border-primary'
          }`}
        >
          <input {...getInputProps()} />
          {isProcessing ? (
            <>
              <Spinner size="lg" />
              <p className="text-default-500">
                Reading file and checking chats…
              </p>
            </>
          ) : (
            <>
              <FiUploadCloud className="w-10 h-10 text-default-400" />
              <p className="text-foreground font-medium">
                Drop a CSV file here, or click to select
              </p>
              <p className="text-sm text-default-500">
                Only .csv files are accepted
              </p>
            </>
          )}
        </div>
      </CardBody>
    </Card>
  );
};
